export default __webpack_public_path__ + "static/media/logo.24347484.png";